import { addStyles, DefaultTheme, rgba } from '../../components/theme';
import { ColorPaletteOrange } from '../../components/theme.palette';

export const CSS = {
	root: 'c-FormMigrateReview__Root',
	heading: 'c-FormMigrateReview__Heading',
	breadcrumb: 'c-FormMigrateReview__Breadcrumb',
	metaBold: 'c-FormMigrateReview__Meta--Bold',
	metaMuted: 'c-FormMigrateReview__Meta--Muted',
	cards: 'c-FormMigrateReview__Cards',
	card: 'c-FormMigrateReview__Card',
	cardValue: 'c-FormMigrateReview__CardValue',
	cardValueWarn: 'c-FormMigrateReview__CardValue--Warn',
	cardLabel: 'c-FormMigrateReview__CardLabel',
	cardSpinner: 'c-FormMigrateReview__CardSpinner',
	lostPanel: 'c-FormMigrateReview__LostPanel',
	tabBar: 'c-FormMigrateReview__TabBar',
	tab: 'c-FormMigrateReview__Tab',
	tabActive: 'c-FormMigrateReview__Tab--Active',
	lossTabScroll: 'c-FormMigrateReview__LossTabScroll',
	lostRow: 'c-FormMigrateReview__LostRow',
	lostIcon: 'c-FormMigrateReview__LostIcon',
	lostText: 'c-FormMigrateReview__LostText',
	lostName: 'c-FormMigrateReview__LostName',
	lostMeta: 'c-FormMigrateReview__LostMeta',
	lostEmpty: 'c-FormMigrateReview__LostEmpty',
	lostRowCount: 'c-FormMigrateReview__LostRowCount',
	lostRowSpinner: 'c-FormMigrateReview__LostRowSpinner',
	dropdownLossRow: 'c-FormMigrateReview__DropdownLossRow',
	dropdownLossRowHeader: 'c-FormMigrateReview__DropdownLossRowHeader',
	dropdownLossChevron: 'c-FormMigrateReview__DropdownLossChevron',
	dropdownLossCount: 'c-FormMigrateReview__DropdownLossCount',
	dropdownLossValues: 'c-FormMigrateReview__DropdownLossValues',
	dropdownLossValue: 'c-FormMigrateReview__DropdownLossValue',
	dropdownLossValueLabel: 'c-FormMigrateReview__DropdownLossValueLabel',
	dropdownLossValueCollections: 'c-FormMigrateReview__DropdownLossValueCollections',
	footerNote: 'c-FormMigrateReview__FooterNote',
	footerNoteIcon: 'c-FormMigrateReview__FooterNoteIcon',
};

addStyles({
	[CSS.root]: {
		'padding-bottom': DefaultTheme.space(1),
	},
	[CSS.heading]: {
		'font-size': '1.3rem',
		'font-weight': 700,
		'padding-bottom': DefaultTheme.space(2),
	},
	[CSS.breadcrumb]: {
		'padding-bottom': DefaultTheme.space(4),
	},
	[CSS.metaBold]: {
		color: DefaultTheme.font.color.primary,
		'font-weight': 700,
	},
	[CSS.metaMuted]: {
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.cards]: {
		display: 'grid',
		'grid-template-columns': 'repeat(4, 1fr)',
		gap: DefaultTheme.space(3),
		'padding-bottom': DefaultTheme.space(4),
	},
	[CSS.card]: {
		border: `1px solid ${DefaultTheme.font.color.divider}`,
		'border-radius': '4px',
		padding: DefaultTheme.space(3),
		background: DefaultTheme.background.offWhite,
	},
	[CSS.cardValue]: {
		'font-size': '1.8rem',
		'font-weight': 700,
		color: DefaultTheme.font.color.primary,
	},
	[CSS.cardValueWarn]: {
		color: DefaultTheme.font.color.error,
	},
	[CSS.cardLabel]: {
		'font-size': '0.8rem',
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.cardSpinner]: {
		width: '24px',
		height: '24px',
		'& > div': {
			width: '16px',
			height: '16px',
		},
	},
	[CSS.lostPanel]: {
		border: `1px solid ${DefaultTheme.font.color.divider}`,
		'border-radius': '4px',
		background: DefaultTheme.background.offWhite,
		overflow: 'hidden',
	},
	[CSS.tabBar]: {
		display: 'flex',
		background: DefaultTheme.background.lightGrey,
		'border-bottom': `1px solid ${DefaultTheme.font.color.divider}`,
	},
	[CSS.tab]: {
		flex: '1 1 0',
		'min-width': 0,
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
		'font-weight': 700,
		'font-size': '0.9rem',
		color: DefaultTheme.font.color.supporting,
		cursor: 'pointer',
		'border-bottom': '2px solid transparent',
		'margin-bottom': '-1px',
	},
	[CSS.tabActive]: {
		color: DefaultTheme.font.color.primary,
		'border-bottom-color': DefaultTheme.color.accent,
	},
	/** Fixed (not content-driven) and shared by both tabs, so the modal's overall size never changes —
	 *  neither between tabs nor based on how many items either list holds. */
	[CSS.lossTabScroll]: {
		height: '200px',
		'overflow-y': 'auto',
		'overflow-x': 'hidden',
	},
	[CSS.lostRow]: {
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(2),
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
		'border-top': `1px solid ${DefaultTheme.font.color.divider}`,
	},
	[`${CSS.lossTabScroll} > ${CSS.lostRow}:first-child`]: {
		'border-top': 'none',
	},
	[CSS.lostIcon]: {
		'font-size': '20px',
		color: DefaultTheme.font.color.supporting,
		'flex-shrink': 0,
	},
	[CSS.lostText]: {
		'min-width': 0,
	},
	[CSS.lostName]: {
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
		'font-weight': 700,
		color: DefaultTheme.font.color.primary,
	},
	[CSS.lostMeta]: {
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
		'font-size': '0.8rem',
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.lostEmpty]: {
		// Same fixed height as CSS.lossTabScroll — an empty tab shouldn't change the modal's size either.
		height: '200px',
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		'text-align': 'center',
		padding: DefaultTheme.space(3),
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.lostRowCount]: {
		'margin-left': 'auto',
		'flex-shrink': 0,
		'font-size': '0.8rem',
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.lostRowSpinner]: {
		width: '16px',
		height: '16px',
		'& > div': {
			width: '12px',
			height: '12px',
		},
	},
	[CSS.dropdownLossRow]: {
		'border-top': `1px solid ${DefaultTheme.font.color.divider}`,
	},
	[`${CSS.lossTabScroll} > ${CSS.dropdownLossRow}:first-child`]: {
		'border-top': 'none',
	},
	[CSS.dropdownLossRowHeader]: {
		cursor: 'pointer',
		'list-style': 'none',
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(2),
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
		'&::-webkit-details-marker': {
			display: 'none',
		},
	},
	[CSS.dropdownLossChevron]: {
		'font-size': '20px',
		color: DefaultTheme.font.color.supporting,
		'flex-shrink': 0,
		transition: 'transform 0.15s ease',
	},
	[`${CSS.dropdownLossRow}[open] > .${CSS.dropdownLossRowHeader} .${CSS.dropdownLossChevron}`]: {
		transform: 'rotate(90deg)',
	},
	[CSS.dropdownLossCount]: {
		'margin-left': 'auto',
		'flex-shrink': 0,
		'font-size': '0.8rem',
		'font-weight': 700,
		color: rgba(ColorPaletteOrange.C900),
	},
	[CSS.dropdownLossValues]: {
		display: 'flex',
		'flex-direction': 'column',
		gap: DefaultTheme.space(2),
		padding: `0 ${DefaultTheme.space(3)} ${DefaultTheme.space(3)} ${DefaultTheme.space(9)}`,
	},
	[CSS.dropdownLossValue]: {
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'space-between',
		gap: DefaultTheme.space(2),
		padding: `${DefaultTheme.space(1)} ${DefaultTheme.space(2)}`,
		'border-radius': '4px',
		background: rgba(ColorPaletteOrange.C900, 0.08),
	},
	[CSS.dropdownLossValueLabel]: {
		'font-weight': 700,
		'font-size': '0.8rem',
		color: rgba(ColorPaletteOrange.C900),
		'min-width': 0,
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
	},
	[CSS.dropdownLossValueCollections]: {
		'flex-shrink': 0,
		'font-size': '0.75rem',
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.footerNote]: {
		position: 'sticky',
		bottom: 0,
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(2),
		padding: `${DefaultTheme.space(3)} 0`,
		background: DefaultTheme.background.offWhite,
		'border-top': `1px solid ${DefaultTheme.font.color.divider}`,
		color: DefaultTheme.font.color.supporting,
		'font-size': '0.85rem',
	},
	[CSS.footerNoteIcon]: {
		'font-size': '18px',
		'flex-shrink': 0,
	},
});
